var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"api-key-icon-table-cell"},[_c('div',{staticClass:"api-key-icon-table-cell__icon"},[_c('DigitalKey')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }